const handleClick = (
  travelId: string,
  callback?: (travelId?: string) => void,
) => {
  if (callback) {
    callback(travelId);
  }
};

export function handleClickRateDriver(id: string) {
  handleClick(id, () => {
    window.localStorage.setItem('companyEvaluating_toggleDenounce', 'open');
    window.localStorage.setItem('companyEvaluating_travelId', id || '');
    window.dispatchEvent(new Event('companyEvaluating_toggleCreateDenounce'));
  });
}
